/** Dates civiles locales : aucune conversion UTC susceptible de décaler le jour. */
export const dateKey = (date: Date): string =>
  `${String(date.getFullYear()).padStart(4, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
export const parseDateKey = (value: string): Date | null => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T12:00:00`);
  return !Number.isNaN(date.getTime()) && dateKey(date) === value ? date : null;
};
export const shiftDays = (value: string, days: number): string => {
  const date = parseDateKey(value)!;
  date.setDate(date.getDate() + days);
  return dateKey(date);
};
export const shiftMonth = (value: string, months: number): string => {
  const date = parseDateKey(value)!;
  const day = date.getDate();
  date.setDate(1);
  date.setMonth(date.getMonth() + months);
  const last = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  date.setDate(Math.min(day, last));
  return dateKey(date);
};
export const calendarDays = (month: string): string[] => {
  const first = `${month}-01`;
  const weekday = (parseDateKey(first)!.getDay() + 6) % 7;
  return Array.from({ length: 42 }, (_, index) => shiftDays(first, index - weekday));
};
export const formatDateKey = (value: string): string => {
  const date = parseDateKey(value);
  return date ? date.toLocaleDateString('fr-FR') : '';
};
export interface DateRange {
  from: string;
  to: string;
}
